module.exports = __webpack_public_path__ + "main/images/learnmore/ff-brand-icon-responsive-full-color.16821f55a71babf1bab599685a91f542.svg";